'use strict';

function playFinderCelebration(button){
 playFinderConfetti(button);
 playFinderChime();
}

function playFinderConfetti(button){
 const rect=button.getBoundingClientRect();
 const originX=rect.left+rect.width/2;
 const originY=rect.top+rect.height/2;
 if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
  document.querySelector('.finder-confetti')?.remove();
  const layer=document.createElement('div');
  layer.className='finder-confetti';
  layer.setAttribute('aria-hidden','true');
  document.body.append(layer);
  const colours=['#D6FF5F','#0A7968','#4B73AD','#C7473D','#FFFFFF'];
  for(let i=0;i<165;i++){
   const piece=document.createElement('i');
   const spread=(Math.random()-.5)*Math.min(innerWidth*1.1,1250);
   const rise=originY+90+Math.random()*innerHeight*.38;
   const drift=(Math.random()-.5)*110;
   const fall=innerHeight-originY+80+Math.random()*130;
   const turn=(Math.random()>.5?1:-1)*(420+Math.random()*900);
   piece.style.left=originX+'px';
   piece.style.top=originY+'px';
   piece.style.width=(4+Math.random()*7)+'px';
   piece.style.height=(9+Math.random()*13)+'px';
   piece.style.background=colours[i%colours.length];
   layer.append(piece);
   piece.animate([
    {transform:'translate3d(0,0,0) rotate(0deg) scale(.35)',opacity:1,offset:0},
    {transform:`translate3d(${spread*.25}px,${-rise*.42}px,0) rotate(${turn*.18}deg) scale(1)`,opacity:1,offset:.15},
    {transform:`translate3d(${spread}px,${-rise}px,0) rotate(${turn*.42}deg) scale(1)`,opacity:1,offset:.37},
    {transform:`translate3d(${spread+drift}px,${-rise*.65}px,0) rotate(${turn*.6}deg) scale(.9)`,opacity:1,offset:.57},
    {transform:`translate3d(${spread-drift*.5}px,${-rise*.12}px,0) rotate(${turn*.82}deg) scale(1)`,opacity:1,offset:.78},
    {transform:`translate3d(${spread+drift*.7}px,${fall}px,0) rotate(${turn}deg) scale(.8)`,opacity:0,offset:1}
   ],{duration:2900+Math.random()*900,delay:Math.random()*45,easing:'cubic-bezier(.19,.48,.35,1)',fill:'forwards'});
  }
  setTimeout(()=>layer.remove(),4100);
 }
}

function playFinderChime(){
 try{
  const Audio=window.AudioContext||window.webkitAudioContext;
  if(!Audio)return;
  const context=new Audio();
  context.resume().catch(()=>{});
  const master=context.createGain();
  master.gain.value=.2;
  master.connect(context.destination);
  const now=context.currentTime+.01;
  const notes=[{frequency:1046.5,offset:0,duration:.12},{frequency:1567.98,offset:.105,duration:.19}];
  for(const {frequency,offset,duration} of notes){
   const start=now+offset;
   const tone=context.createOscillator();
   const volume=context.createGain();
   tone.type='square';
   tone.frequency.value=frequency;
   volume.gain.setValueAtTime(.0001,start);
   volume.gain.linearRampToValueAtTime(.23,start+.004);
   volume.gain.exponentialRampToValueAtTime(.07,start+.055);
   volume.gain.exponentialRampToValueAtTime(.0001,start+duration);
   tone.connect(volume);volume.connect(master);
   tone.start(start);tone.stop(start+duration+.005);
  }
  setTimeout(()=>context.close().catch(()=>{}),600);
 }catch{}
}


if (!window.fsPurchaseConfettiBound) {
 window.fsPurchaseConfettiBound = true;
 window.addEventListener('click', event => {
  const button = event.target.closest?.('#buy-product .fs-native-buy-actions button, [data-fs-liquid-add], [data-fs-liquid-finish], #result-buy-selected, #result-cart-selected');
  const action=button||event.target.closest?.('button,a,input[type=submit]');
  if(action&&!action.disabled&&(button||/^(buy now|add to cart|proceed to checkout|secure checkout)$/i.test((action.textContent||action.value||'').trim()))) playFinderConfetti(action);
 }, true);
}
